import { useQuery } from 'react-query';

import { getCardMatrixCountersData as queryFn } from 'api/endPoints/getCardMatrixCountersData';
import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useQueryGetMatrixData = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['useQueryGetMatrixData', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.versionId) && Boolean(params.numOfDaysToBeUrgent),
    });
};

export interface QueryParams {
    versionId: number | undefined;
    numOfDaysToBeUrgent: number | null;
    filter: { filters: IFilter[] };
}

export interface QueryResponse {
    doNowComponent: {
        title: string;
        itemRecommendation: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemUserActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemProgramActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
    };
    doNextComponent: {
        title: string;
        itemRecommendation: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemUserActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemProgramActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
    };
    prioritizeComponent: {
        title: string;
        itemRecommendation: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemUserActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemProgramActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
    };
    laterComponent: {
        title: string;
        itemRecommendation: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemUserActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
        itemProgramActivities: {
            title: string;
            matrixItemIndex: number;
            numOfItem: number;
            numOfOverdue: number;
            numOfDelayDriver: number;
            numOfCriticalPath: number;
            numOfAssignedToMe: number;
        };
    };
    info: IToolTip;
}
